/** Card 6 — explore the Memory Lane roadmap without an account. */
import React, { useState } from "react";
import { ROADMAP_STAGES } from "@/lib/roadmapStages";
import { TransitionPanel, DemoBadge, trackStep, trackCompleted } from "../activationShared";

const STOPS = [
    { key: "first_concerns", label: "Noticing changes" },
    { key: "getting_answers", label: "Evaluation" },
    { key: "diagnosis_next", label: "Diagnosis" },
    { key: "care_coordination", label: "GUIDE" },
    { key: "transitions", label: "Home health" },
    { key: "hospice_comfort", label: "Hospice" },
];

export default function RoadmapExplorer({ onClose }) {
    const [active, setActive] = useState(null);
    const stage = active ? ROADMAP_STAGES.find((s) => s.key === active) : null;

    return (
        <div data-testid="activation-roadmap">
            <DemoBadge>Explore freely — no account needed</DemoBadge>
            <h3 className="mt-4 font-heading font-medium text-lg md:text-xl text-[#1F2624]">
                The road has stops. Tap any of them.
            </h3>
            <p className="mt-1 text-sm text-[#6E7A74]">Most families are handed a diagnosis and no map. This is the map.</p>
            <div className="mt-4 flex flex-wrap gap-2">
                {STOPS.map((s, i) => {
                    const st = ROADMAP_STAGES.find((x) => x.key === s.key);
                    return (
                        <button key={s.key} type="button" data-testid={`roadmap-stop-${s.key}`}
                            onClick={() => { setActive(s.key); trackStep("roadmap_explorer", s.key); trackCompleted("roadmap_explorer"); }}
                            className={`rounded-2xl px-4 py-2 text-sm font-medium border transition-all ${active === s.key ? "text-white shadow-sm" : "bg-white text-[#2A3330] border-[#E2E8F0] hover:-translate-y-0.5"}`}
                            style={active === s.key ? { backgroundColor: st?.color, borderColor: st?.color } : undefined}>
                            {i + 1}. {s.label}
                        </button>
                    );
                })}
            </div>
            {stage && (
                <div className="mt-4 rounded-2xl border border-[#E2E8F0] bg-white p-5" data-testid="roadmap-stage-detail">
                    <p className="text-xs font-semibold uppercase tracking-wider" style={{ color: stage.color }}>{stage.title}</p>
                    <p className="mt-1 font-heading font-medium text-lg text-[#1F2624]">{stage.tagline}</p>
                    <p className="mt-2 text-sm text-[#2A3330] leading-relaxed">{stage.meaning}</p>
                    <p className="mt-3 text-sm font-semibold text-[#1F2624]">What families usually do here:</p>
                    <ul className="mt-1.5 space-y-1.5">
                        {(stage.next_steps || []).slice(0, 3).map((s) => (
                            <li key={s} className="text-sm text-[#4C5551] leading-relaxed pl-4 relative">
                                <span className="absolute left-0 top-[7px] w-1.5 h-1.5 rounded-full" style={{ backgroundColor: stage.color }} />{s}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
            {stage && <TransitionPanel card="roadmap_explorer" onClose={onClose} ctaLabel="Create your free account — we'll mark where you are" />}
        </div>
    );
}
